import React from "react";
import * as PropTypes from "prop-types";
import { Typography } from "@mui/material";
import Loader from "../assets/logo/loader.svg";
import Check from "../assets/logo/check.svg";
import Cross from "../assets/logo/cross.svg";
import { useTranslation } from "react-i18next";

export default function AppStatus({ status = 0, donotShow = null, logo= true, errorColor = "#e37272", fontSize=14, progressColor="#F8F8F8" }) {
  const { t } = useTranslation();
  if (status === 0 && donotShow !== 0) {
    return (
      <Typography
        fontSize={fontSize}
        fontWeight={400}
        fontFamily="Manrope"
        color={progressColor}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {logo && <Loader className="loader" style={{ width: 20, height: 20 }} />}
        &nbsp;&nbsp;{t("status.Inprogress")}
      </Typography>
    );
  }
  if (status === 1 && donotShow !== 1) {
    return (
      <Typography
        fontSize={fontSize}
        fontWeight={400}
        fontFamily="Manrope"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {logo && <Check style={{ width: 20, height: 20 }} />} &nbsp;&nbsp; {t("status.Success")}
      </Typography>
    );
  }
  if ((status === 2 || status === 3 || status === 4 || status === 5) && ![2, 3, 4, 5].includes(donotShow)) {
    return (
      <Typography
        fontSize={fontSize}
        fontWeight={400}
        fontFamily="Manrope"
        color={errorColor}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {logo && <Cross
          style={{
            width: 20,
            height: 20,
            background: "#DC2626",
            borderRadius: "50%",
          }}
        />}
        &nbsp;&nbsp;{t("status.Failed")}
      </Typography>
    );
  }
}

AppStatus.propTypes = {
  status: PropTypes.number, // 0 = pending, 1 = success ,2 =failed
};
